export default __webpack_public_path__ + "static/media/icons8-info.41dea492.svg";